import { PageContainer, PageHeader } from "@touche-lts/panel-ui/dist"
import { IconUserManagement } from 'assets/icons'
import { useRootStore } from "mobx-stores/store-provider"
import { useEffect } from "react"
import { CustomersTable } from "./customers-table/customers-table-page"

const CustomersPageComponent = (props) => {
  const {
    className,
    style,
    history: { push }
  } = props,
    {
      departmentsStore: {
        resetStore
      }
    } = useRootStore()

  useEffect(() => {
    resetStore()
  }, [resetStore])

  return (
    <PageContainer className={className} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'Customers',
            iconProps: { viewBox: '0 0 22 22' }
          }
        ]}
      />
      <CustomersTable style={{overflowX: 'auto'}} />
    </PageContainer>
  )
}

const CustomersPage = CustomersPageComponent
export { CustomersPage }
